import React, { useRef } from 'react'
import { Avatar, Modal, Tooltip } from 'antd'
import { UserOutlined, DeleteFilled, EditFilled } from '@ant-design/icons'
import { ContactsWrapper, EditDelWrapper, ProfileContent, ProfilePicWrapper, ShowMore } from '../dashboard.styled'
import { ContactType } from '../../../constants/DashboardConf'

const { EMAIL, LINE, WHATSAPP, INSTAGRAM, FACEBOOK, YOUTUBE, TWITTER, LINKEDIN, TIKTOK } = ContactType
function Profile (props) {
  const { data, settingMode, actions } = props
  const { UISetting, colId, ruleType, content = {} } = data || {}
  const { profilePicture, name, phoneNumber, email, contacts } = UISetting || {}
  const { handleEdit, handleDelete } = actions
  const wrapperRef = useRef()
  const changeLater = true

  const contactIcon = {
    [EMAIL]: '/contacts/gmail.png',
    [LINE]: '/contacts/line.png',
    [WHATSAPP]: '/contacts/whatsapp.png',
    [INSTAGRAM]: '/contacts/instagram.png',
    [FACEBOOK]: '/contacts/facebook.png',
    [YOUTUBE]: '/contacts/youtube.png',
    [TWITTER]: '/contacts/twitter.png',
    [LINKEDIN]: '/contacts/linkedin.png',
    [TIKTOK]: '/contacts/tiktok.png'
  }

  const handleRedirect = data => {}

  const handleShowMore = (value, title) => {
    Modal.info({
      title,
      content: value?.join(', ')
    })
  }
  const formatContent = (value, title) => Array.isArray(value)
    ? <span>
        {value[0]}
        {value.length > 1 ? <ShowMore onClick={() => handleShowMore(value, title)}>[...]</ShowMore> : ''}
      </span>
    : value

  return (
    <ProfileContent ref={wrapperRef}>
      {settingMode
        ? <EditDelWrapper profile="true">
            <div><EditFilled onClick={() => handleEdit(colId, ruleType, 'edit', data)}/></div>
            <div><DeleteFilled onClick={() => handleDelete(data)}/></div>
          </EditDelWrapper>
        : ''}
      {profilePicture ? <ProfilePicWrapper>{changeLater ? <Avatar size={110} icon={<UserOutlined />} /> : ''}</ProfilePicWrapper> : ''}
      <div style={{ fontWeight: 500, fontSize: '16px', paddingBottom: '8px' }}>
        {name ? settingMode ? 'User Name' : formatContent(content[name], name) : ''}
      </div>
      <div style={{ color: 'rgba(0,0,0,.4)', paddingBottom: '4px' }}>
        {email ? settingMode ? 'username@gmail.com' : formatContent(content[email], email) : ''}
      </div>
      <div style={{ paddingBottom: '8px' }}>
        {phoneNumber ? settingMode ? '+886 1212 300 456' : formatContent(content[phoneNumber], phoneNumber) : ''}
      </div>
      {contacts && contacts?.length
        ? <ContactsWrapper>
            {contacts?.map(i => (
              <Tooltip key={i.contactType} title={i.contactType}>
                <img src={contactIcon[i.contactType]} alt={i.contactType} onClick={() => handleRedirect(i)} />
              </Tooltip>
            ))}
          </ContactsWrapper>
        : ''
      }
    </ProfileContent>
  )
}

export default Profile
